import '../assets/NcAppNavigationCaption-l5yRGXZx.css';
import { N as a } from "./NcActions-qCVw08zV.mjs";
import { n as s } from "./_plugin-vue2_normalizer-u6G_3nkj.mjs";
const i = {
  name: "NcAppNavigationCaption",
  components: {
    NcActions: a
  },
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      required: !0
    },
    /**
     * Any [NcActions](#/Components/NcActions?id=ncactions-1) prop
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {}
  },
  computed: {
    // Check if the actions slot is populated
    hasActions() {
      return !!this.$slots.actions;
    }
  }
};
var o = function() {
  var n = this, t = n._self._c;
  return t("li", { staticClass: "app-navigation-caption" }, [t("span", { staticClass: "app-navigation-caption__name" }, [n._v(" " + n._s(n.name) + " ")]), n.hasActions ? t("div", { staticClass: "app-navigation-caption__actions" }, [t("NcActions", n._g(n._b({ scopedSlots: n._u([{ key: "icon", fn: function() {
    return [n._t("actionsTriggerIcon")];
  }, proxy: !0 }], null, !0) }, "NcActions", n.$attrs, !1), n.$listeners), [n._t("actions")], 2)], 1) : n._e()]);
}, e = [], c = /* @__PURE__ */ s(
  i,
  o,
  e,
  !1,
  null,
  "dbde4a28",
  null,
  null
);
const l = c.exports;
export {
  l as N
};
